$.fn.stairsEffect = function() {
  let self = this
  self.cols = self.find('.col')

  self.init_offset = function() {
    self.cols.each(function(index) {
      $(this).data('transform-top', 25 * index)
      $(this).data('transform-left', 28 * (index + .5))
    })
    setTimeout(function() {
      self.addClass('stairs-effect--loaded')
    }, 250)
  }

  self.init_scroll = function() {
    $.mlmi.scroll.add(function(top) {
      let headerHeight = $('.header').outerHeight(false) + 32,
      maxY = Math.min($(window).height() - headerHeight, 600)
      self.cols.each(function() {
        let topY = $(this).offset().top - top - headerHeight,
        percentPadding = topY / maxY
        $(this).css({
          'transform': $.mlmi.mobile.isMobile ? 'translateX(' + Math.max($(this).data('transform-left') * percentPadding, 0) + 'px)' : 'translateY(' + Math.max($(this).data('transform-top') * percentPadding, 0) + '%)',
        })
      })
    })
  }

  return function() {
    self.init_offset()
    self.init_scroll()
    return self
  }()
}
